import {useEffect, useState} from 'react';
import {language} from '../../language';
import {useSelector} from 'react-redux';

const LastDateBuyBanner = () => {
  const hrMobileLanguage = useSelector((state) => state.app.slsHrMobileLanguage);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // const now = new Date('2025-06-01T12:00:00+07:00');
    const now = new Date();
    const bkkOffset = 7 * 60;
    const localOffset = now.getTimezoneOffset();
    const bkkNow = new Date(now.getTime() + (bkkOffset + localOffset) * 60000);

    const start = new Date('2025-06-01T00:00:00+07:00');
    const end = new Date('2025-06-12T23:59:59+07:00');

    if (bkkNow >= start && bkkNow <= end) {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  return (
    <div style={{position: 'sticky', top: 0, background: 'white', zIndex: 6, marginTop: '-8px'}}>
      <div
        className="text-center py-3 border-bottom"
        style={{
          overflowX: 'scroll',
          whiteSpace: 'nowrap',
          backgroundColor: '#f97c89',
          marginLeft: '-10px',
          marginRight: '-10px',
          color: '#ffffff',
          padding: '0 16px',
        }}
      >
        {language?.lastDateBuyBannerMsg?.[hrMobileLanguage]}
      </div>
    </div>
  );
};

export default LastDateBuyBanner;
